import React, { useEffect, useState } from "react";

const INITIAL_QUERIES = 3472;

const getInitialCounter = () => {
  const saved = localStorage.getItem("coraa_query_counter");
  return saved
    ? parseInt(saved, 10)
    : (localStorage.setItem("coraa_query_counter", INITIAL_QUERIES.toString()),
      INITIAL_QUERIES);
};

export const CoraaHeroSection: React.FC = () => {
  const [counter, setCounter] = useState<number>(getInitialCounter());
  const [fade, setFade] = useState(true);

  useEffect(() => {
    setCounter(getInitialCounter());
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setFade(true);
        setCounter((prev) => {
          const increment = 50 + Math.floor(Math.random() * 20);
          const next = prev + increment;
          localStorage.setItem("coraa_query_counter", next.toString());
          return next;
        });
      }, 400);
    }, 2 * 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="w-full relative rounded-2xl mb-6 flex items-center justify-between px-6 py-3 overflow-hidden shadow-xl border border-white/30 bg-white/60 backdrop-blur-md">
      <div className="absolute inset-0 z-0 pointer-events-none" aria-hidden>
        <div className="w-full h-full bg-gradient-to-tr from-green-200/40 via-green-100/20 to-blue-200/40 animate-gradient-move" />
      </div>
      <div className="relative z-10 flex items-center gap-3">
        <span className="inline-block rounded-full bg-gradient-to-br from-green-400 via-green-600 to-blue-400 p-0.5">
          <span className="block bg-white rounded-full p-0.5 relative h-9 w-9 flex items-center justify-center overflow-hidden">
            <img
              src="/images/coraa-mascot.png"
              alt="Coraa Mascot"
              className="h-full w-full object-cover"
            />
            <span className="absolute -top-1 -right-1 bg-gradient-to-tr from-green-500 to-blue-400 text-white text-[10px] rounded-full px-1 py-0 shadow-lg animate-pulse">
              AI
            </span>
          </span>
        </span>
        <h2 className="text-xl font-bold text-green-900 drop-shadow-lg whitespace-nowrap">
          CORAA: Your Impact Copilot, Always On
        </h2>
      </div>
      <div className="relative z-10 text-green-800 font-semibold transition-all duration-500">
        <span
          className={`inline-block transition-opacity duration-400 ${
            fade ? "opacity-100" : "opacity-0"
          }`}
          key={counter}
        >
          {`Over ${counter.toLocaleString()} queries answered this month. What's yours?`}
        </span>
      </div>
      <style>{`
        @keyframes gradient-move { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
        .animate-gradient-move { background-size: 200% 200%; animation: gradient-move 8s ease-in-out infinite; }
        .animate-coraa-glow { box-shadow: 0 0 16px 4px #34d39988, 0 0 32px 8px #60a5fa44; animation: coraa-glow 2.5s ease-in-out infinite alternate; }
        @keyframes coraa-glow { 0% { filter: drop-shadow(0 0 8px #34d39988); } 100% { filter: drop-shadow(0 0 24px #60a5fa); } }
      `}</style>
    </section>
  );
};

export default CoraaHeroSection;
